import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { KeyboardService } from "app/services/keyboard.service";

@Component({
    selector: "app-numpad",
    templateUrl: "./numpad.component.html",
    styleUrls: ["./numpad.component.scss"],
    standalone: false
})
export class NumpadComponent implements OnInit {
  prevRoute: string = "";
  value: string = "0";
  keys: string[] = [
    "7",
    "8",
    "9",
    "Close",
    "4",
    "5",
    "6",
    "CE",
    "1",
    "2",
    "3",
    "OK",
    "+/-",
    "0",
    ".",
  ];
  okKey = "OK";
  inputId: string = "";
  @ViewChild("keyValue") inputValue: ElementRef;

  constructor(
    private route: ActivatedRoute,
    public keyboardService: KeyboardService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe({
      next: (value) => {
        if (value["inputId"] != null) {
          this.inputId = value["inputId"];
        }
        if (value["value"] != null) {
          this.value = value["value"];
        }
      },
    });
    this.prevRoute = this.keyboardService.getRoute() ?? '';
  }

  onKeyClick(event: string) {
    this.focus();
    const key = event;
    if (key == "+/-") {
      if (this.value != null && this.value != "0") {
        if (this.value.includes("-")) this.value = this.value.substring(1);
        else this.value = "-" + this.value;
      }
    } else if (key == "Close") {
      this.onClose();
    } else if (key == "CE") {
      this.value = "0";
    } else if (key == "OK") {
      this.onApply();
    } else if (key == ".") {
      if (!this.value.includes(".")) this.value = this.value + ".";
    } else {
      if (!isNaN(Number(key)))
        if (this.value.startsWith("0") && !this.value.includes("."))
          this.value = "";
      this.value = this.value + key;
    }
  }

  onClose() {
    this.router.navigateByUrl(this.prevRoute);
  }

  onApply() {
    this.keyboardService.setKeyboardValues(
      this.inputId,
      Number(this.value),
      this.prevRoute
    );
    this.onClose();
  }

  focus() {
    this.inputValue.nativeElement.focus();
  }

  getCaracter(c: string): string {
    let key = "";
    switch (c) {
      case "&#x2190;":
        key = "Backspace";
        break;
      default:
        key = c;
        break;
    }
    return key;
  }
}
